import { Button, Dropdown, Tooltip } from 'components/ui'
import { TagContext } from 'contexts/TagContext'
import React, { useContext, useState } from 'react'
import { TbArchive, TbCheck, TbPencil, TbTag } from 'react-icons/tb'

export default function Tag({
  tag,
  onEdit = () => void 0,
  onClickTag = () => void 0,
  selected = false,
  closeOnSelect = false
}) {

  const { toggleActiveTag } = useContext(TagContext);
  const [ isTogglingActive, setIsTogglingActive ] = useState(false);

  const onToggleActive = async () => {
    setIsTogglingActive(true);
    await toggleActiveTag(tag.id);
    setIsTogglingActive(false);
  }

  return (
    <Dropdown.Item 
      className={`py-0 px-4 ${!tag.active && `bg-gray-100 dark:bg-gray-800`} ${selected && `!bg-primary-600/10`}`}
    >
      <div onClick={(e) => { onClickTag(); if (!closeOnSelect) e.stopPropagation(); }} className='group flex items-center justify-between gap-2 h-[40px] w-full'>
        <div className='flex items-center gap-2 flex-1 max-w-[80%] group-hover:max-w-[60%]'>
          {tag.active 
            ? <TbTag className='h-6 md:text-xl shrink-0' style={{ color: tag.active && tag.color }} />
            : <TbArchive className='h-6 md:text-xl shrink-0' style={{ color: tag.active && tag.color }} />
          }
          <span className='block overflow-hidden text-ellipsis whitespace-nowrap flex-1'>{tag.name}</span>
        </div>
        <div className='flex items-center gap-2 shrink-0'>
          <Tooltip title={tag.active ? `Archive` : `Unarchive`}>
            <Button 
              size="xs"
              className="!rounded hidden group-hover:flex"
              onClick={(e) => { e.stopPropagation(); onToggleActive(); }}
              loading={isTogglingActive}
              icon={<TbArchive className='text-gray-400' />}
            />
          </Tooltip>
          <Tooltip title="Edit">
            <Button 
              size="xs"
              className="!rounded hidden group-hover:flex"
              onClick={(e) => { e.stopPropagation(); onEdit() }}
              icon={<TbPencil className='text-gray-400' />}
            />
          </Tooltip>
          {selected && <TbCheck className='text-primary-600 text-xl' />}
        </div>
      </div>
    </Dropdown.Item>
  )
}
